import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { TAssetId } from '/src/lib/models';
import type {
  TCreateAssetRequest,
  TCreateAssetResponse,
  TDeleteAssetResponse,
  TGetAssetResponse,
  TListAssetsRequest,
  TListAssetsResponse,
  TUpdateAssetRequest,
  TUpdateAssetResponse,
} from '/src/lib/types';

export class AssetService {
  /**
   * List Assets
   * @returns Asset[]
   * @throws ApiError
   */
  public static async query(req?: TListAssetsRequest): CancelablePromise<TListAssetsResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/assets',
      query: req,
    })) as TListAssetsResponse;

    return res;
  }

  /**
   * Get Asset Name
   * @param id TAssetId
   * @returns Asset
   * @throws ApiError
   */
  public static async getName(id: TAssetId): CancelablePromise<string> {
    return await __request(OpenAPI, {
      method: 'GET',
      url: '/assets/{id}',
      path: { id },
      query: {
        include: '{_id,name}',
      },
    });
  }

  /**
   * Get Asset
   * @param id TAssetId
   * @returns Asset
   * @throws ApiError
   */
  public static async get(id: TAssetId): CancelablePromise<TGetAssetResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/assets/{id}',
      path: { id },
    })) as TGetAssetResponse;

    return res;
  }

  /**
   * Create Asset
   * @param asset Asset
   * @returns Asset
   * @throws ApiError
   */
  public static async create(req: TCreateAssetRequest): CancelablePromise<TCreateAssetResponse> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/assets',
      body: req,
    })) as TCreateAssetResponse;

    return res;
  }

  /**
   * Update Asset
   * @param asset Asset
   * @returns Asset
   * @throws ApiError
   */
  public static async update(id: TAssetId, req: TUpdateAssetRequest): CancelablePromise<TUpdateAssetResponse> {
    const res = (await __request(OpenAPI, {
      method: 'PUT',
      url: '/assets/{id}',
      path: { id },
      body: req,
    })) as TUpdateAssetResponse;

    return res;
  }

  /**
   * Delete Asset
   * @param id TAssetId
   * @returns Asset
   * @throws ApiError
   */
  public static async remove(id: TAssetId): CancelablePromise<TDeleteAssetResponse> {
    const res = (await __request(OpenAPI, {
      method: 'DELETE',
      url: '/assets/{id}',
      path: { id },
    })) as TDeleteAssetResponse;

    return res;
  }
}
